import PropTypes from 'prop-types';

import { Announcement, HelpV2Icon, InfoFilledIcon, OverlayTriggerTooltip } from '@utilities';

import { getMaxDiffQuestionInfo } from '../../../../../../utilities/helpers';

import styles from './_index.module.scss';

const MaxDiffAnnouncement = ({ question }) => {
  const { numberOfSets, optionsPerSet, questionCost, timesPerExperiment } =
    getMaxDiffQuestionInfo(question);

  return (
    <Announcement
      className={styles['max-diff-announcement']}
      icon={<InfoFilledIcon />}
      text={
        <>
          <strong>
            This will count as {questionCost} question{questionCost !== 1 ? 's' : ''} for your
            survey.
          </strong>{' '}
          It will be displayed as {numberOfSets} separate questions; each question will show{' '}
          {optionsPerSet} options; each option will show {timesPerExperiment} time(s) in the
          experiment.
          <OverlayTriggerTooltip content="This is to improve the quality of data and the panelist experience; the time and effort required to answer 5 rotations is similar to answering a single longer multi-select or open-ended question.">
            <HelpV2Icon className={styles['max-diff-announcement-help-icon']} />
          </OverlayTriggerTooltip>
        </>
      }
      variant="info"
    />
  );
};

MaxDiffAnnouncement.propTypes = {
  question: PropTypes.object.isRequired,
};

export default MaxDiffAnnouncement;
